import domready from 'domready/ready.min';
import GLightbox from 'glightbox';

const banners = domready(function () {


    const loading = GLightbox({
        elements: [
            {
                'content': document.getElementById('spam-bot-check-modal'),
                'width': 450,
                'height': 240,
                'closeButton': false
            },
        ]
    });


    if(typeof check_bot !== 'undefined' && check_bot){
        setTimeout(async function () {
            let bot_detector_event_token = localStorage.getItem('bot_detector_event_token');
            let token = '';
            if (bot_detector_event_token) {
                bot_detector_event_token = JSON.parse(bot_detector_event_token);
                token = bot_detector_event_token.value;
            }
            let sent_data = new FormData();
            sent_data.append('action', 'check_bot');
            sent_data.append('token', token);

            loading.open();

            let ajaxResponse = await fetch(`/blacklists?action=check_bot&token=${token}`);
            try {
                const data = await ajaxResponse.json();
                if (data.allow) {
                    setTimeout(function () {
                        loading.close();
                    }, 2000);
                } else {
                    location.reload();
                }
            } catch (e) {
                loading.close();
            }
        }, 2000);
    }

    const BOT_TOKEN_LIFETIME = 600;
    const BOT_TOKEN_CHECK_INTERVAL = 2000;
    let lastBotTimestamp = null;
    function setBotTokenCookie() {
        const raw = localStorage.getItem('bot_detector_event_token');
        if (!raw) return;

        try {
            const data = JSON.parse(raw);
            if (!data.value || !data.timestamp) return;

            if (data.timestamp !== lastBotTimestamp) {
                lastBotTimestamp = data.timestamp;
                const expiresDate = new Date((data.timestamp + BOT_TOKEN_LIFETIME) * 1000).toUTCString();
                document.cookie = `bot_detector_event_token=${encodeURIComponent(data.value)}; expires=${expiresDate}; path=/; SameSite=Lax`;
            }
        } catch (_) {}
    }
    setBotTokenCookie();
    setInterval(setBotTokenCookie, BOT_TOKEN_CHECK_INTERVAL);

    if(bannerLimit){
        const limitBanner = GLightbox({
            elements: [
                {
                    'content': document.getElementById('modal_limit'),
                    'width': 450,
                    'height': 140,
                    'closeButton': true
                },
            ]
        });
        limitBanner.open();
    }
})

export default banners;
